module.exports = __webpack_public_path__ + "img/portada5.0fc6aea9.png";